export const TITLE = "Notifications";

export const MARK_ALL_READ_TEXT = "Mark all as read";

export const EMPTY_STATE_TEXT = "No new notifications";
